"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEventListPageActions;
(function (EventEventListPageActions) {
    EventEventListPageActions["DataLoaded"] = "DataLoaded";
})(EventEventListPageActions || (EventEventListPageActions = {}));
exports.default = EventEventListPageActions;
